import DragController from 'components/drag-controller/DragController';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
class HomeProducts extends Component {
    delta = 0;
    mouse = {
        x: 0,
        prevX: 0,
        startTime: null
    };
    _grabbing = false;
    _moving = false;
    _native = false;
    _currentItem = 0;
    _switching = false;
    fraction = 0;
    animation;
    get switching() {
        return this._switching;
    }
    get grabbing() {
        return this._grabbing;
    }
    get currentItem() {
        return this._currentItem;
    }
    get moving() {
        return this._moving;
    }
    get native() {
        return this._native;
    }
    set grabbing(value) {
        this._grabbing = value;
        if (value)
            this.refs.slider.classList.add('grabbing');
        else
            this.refs.slider.classList.remove('grabbing');
    }
    set moving(value) {
        this._moving = value;
        if (value) {
            this.refs.slider.classList.add('moving');
        }
        else {
            this.refs.slider.classList.remove('moving');
            this._grabbing = false;
            this._moving = false;
        }
    }
    set switching(value) {
        this._switching = value;
        this.refs.slider.classList.toggle('switching', value);
    }
    set currentItem(value) {
        this._currentItem = value;
        if (this.refs.prev)
            this.refs.prev.classList.toggle('disabled', value === 0);
        if (this.refs.next)
            this.refs.next.classList.toggle('disabled', value === this.refs.items.length - 3);
    }
    set native(value) {
        if (value) {
            this.delta = 0;
            this.refs.items.forEach((item) => {
                item.style.transform = '';
            });
            this.el.classList.add('native');
            this._native = true;
        }
        else {
            this.el.classList.remove('native');
            this._native = false;
        }
    }
    getModulesMap() {
        return {
            dragController: ['.home-products__inner', DragController]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            itemsVisible: 3
        };
    }
    initialized() {
        super.initialized();
    }
    bindEvents(add) {
        const emitterMethod = bindEmitterMethod(add);
        const method = bindMethod(add);
        this.modules.dragController[emitterMethod]('move', () => this.onMove());
        this.refs.prev[method]('click', () => this.modules.dragController.navigate(-1));
        this.refs.next[method]('click', () => this.modules.dragController.navigate(1));
    }
    resize() {
        super.resize();
    }
    onMove() {
        this.refs.prev.classList.toggle('disabled', this.modules.dragController.progress === 0);
        this.refs.next.classList.toggle('disabled', this.modules.dragController.progress === 1);
        this.refs.track.style.transform = `translateX(${this.modules.dragController.progress * (100) * (this.modules.dragController.refs.draggableItems.length - 1)}%)`;
    }
    navigate(direction) { }
}
export default HomeProducts;
